// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"98f7923a","787":"482f2c9c"}[chunkId] + ".chunk.js";
};